<template>
  <section :class="[customClass]" class="js-nav-menu">
    <nav :class="{ wrap: !isMobile }" class="nav nav-menu">
      <nuxt-link
        v-for="item in list"
        :key="item.to"
        :to="item.to"
        class="nav-link"
        :exact="item.to === '/'"
      >
        {{ item.name }}
      </nuxt-link>
    </nav>
  </section>
</template>

<script>
import { computed, defineComponent, useStore } from '@nuxtjs/composition-api'

export default defineComponent({
  props: {
    customClass: {
      type: String,
      required: true
    },
    list: {
      type: Array,
      required: true
    }
  },
  setup() {
    const store = useStore()
    const isMobile = computed(() => store.state.isMobile)

    return {
      isMobile
    }
  }
})
</script>
